import {DateUTC} from '@hconnect/common/types'
import {useUpmPlantContext, useUpmPlantTimezone} from '@hconnect/upm'
import moment, {Moment} from 'moment-timezone'
import {useCallback, useMemo} from 'react'
import {useLocalStorage} from 'react-use'

export enum PageList {
  Instructions = 'Instructions'
}

// Scoped by plant so last-visited timestamps are not shared across plants
export const getLastVisitedKey = (page: PageList, plantUpmId: string) => {
  return `${PageList[page]}_last_visited_${plantUpmId}`
}

type Params = {
  page: PageList
}

export const useLastVisited = ({page}: Params): [Moment | undefined, () => void] => {
  const timezone = useUpmPlantTimezone()
  const {upmId} = useUpmPlantContext()

  const [lastVisited, setLastVisited] = useLocalStorage<DateUTC | undefined>(
    getLastVisitedKey(page, upmId)
  )

  const setMomentLastVisited = useCallback(() => {
    const date = moment().utc().toISOString()
    setLastVisited(date)
  }, [setLastVisited])

  const useMomentLastVisitedState: [Moment | undefined, () => void] = [
    useMemo(
      () => (lastVisited ? moment(lastVisited).tz(timezone) : undefined),
      [lastVisited, timezone]
    ),
    setMomentLastVisited
  ]

  return useMomentLastVisitedState
}
